define("ember-svg-jar/inlined/brand-awareness", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = _exports.default = {
    "content": "<path d=\"M16 13.75v-2h4v2h-4zm1.2 7l-3.2-2.4 1.2-1.6 3.2 2.4-1.2 1.6zm-2-12L14 7.15l3.2-2.4 1.2 1.6-3.2 2.4zm-12.2 7v-6h4l5-5v16l-5-5H3zm7-6.15l-2.15 2.15H5v2h2.85L10 15.9V9.6z\"/>",
    "attrs": {
      "width": "24",
      "height": "25",
      "viewBox": "0 0 24 25",
      "fill": "currentColor",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  };
});